(() => {
  // 0 = oculta la barra de progreso de envío gratis. Cambiar al monto en centavos cuando esté listo.
  const FREE_SHIPPING_THRESHOLD = 0;
  const MONEY_FORMAT = '${{amount}}';

  const state = {
    cart: null,
    open: false,
  };

  const els = {};

  const moneyFormat = (cents) => {
    const value = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `$${value} MXN`;
  };

  const fetchJSON = async (url, opts = {}) => {
    const res = await fetch(url, {
      ...opts,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(opts.headers || {}),
      },
    });
    if (!res.ok) throw new Error(`Cart request failed: ${res.status}`);
    return res.json();
  };

  const getCart = () => fetchJSON('/cart.js');

  const updateLine = (id, quantity) =>
    fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id, quantity }),
    });

  const renderEmpty = () => {
    els.items.innerHTML = '';
    els.items.hidden = true;
    els.empty.hidden = false;
    els.foot.hidden = true;
    els.progress.hidden = true;
  };

  const renderFilled = (cart) => {
    els.items.hidden = false;
    els.empty.hidden = true;
    els.foot.hidden = false;
    els.progress.hidden = FREE_SHIPPING_THRESHOLD <= 0;

    els.items.innerHTML = '';
    const tpl = document.getElementById('cherry-cart-item-template');

    cart.items.forEach((item) => {
      const node = tpl.content.cloneNode(true);
      const root = node.querySelector('[data-cherry-cart-item]');
      root.dataset.key = item.key;
      root.dataset.id = item.id;

      const link = node.querySelector('[data-cherry-cart-item-link]');
      link.href = item.url;

      const img = node.querySelector('[data-cherry-cart-item-img]');
      const fallbacks = window.cherryFallbackImages || [];
      const fallback = fallbacks[(item.product_id || 0) % (fallbacks.length || 1)] || '';
      const primarySrc = item.image
        ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_240x$1$2')
        : (item.featured_image && item.featured_image.url) || fallback;
      img.src = primarySrc || fallback;
      img.alt = item.product_title || '';
      img.addEventListener('error', () => {
        if (fallback && img.src !== fallback) img.src = fallback;
      });

      const vendor = item.vendor || '';
      let displayTitle = item.product_title || '';
      if (vendor && displayTitle.toLowerCase().startsWith(vendor.toLowerCase())) {
        let rest = displayTitle.slice(vendor.length).trim();
        if (rest && /^[—·\-+|]/.test(rest)) rest = rest.slice(1).trim();
        if (rest) displayTitle = rest;
      }
      node.querySelector('[data-cherry-cart-item-name]').textContent = displayTitle;
      node.querySelector('[data-cherry-cart-item-name]').href = item.url;
      const brandEl = node.querySelector('[data-cherry-cart-item-brand]');
      brandEl.textContent = item.vendor || '';
      if (!item.vendor) brandEl.style.display = 'none';

      const variantEl = node.querySelector('[data-cherry-cart-item-variant]');
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantEl.textContent = item.variant_title;
      } else {
        variantEl.style.display = 'none';
      }

      node.querySelector('[data-cherry-cart-item-qty]').textContent = item.quantity;
      node.querySelector('[data-cherry-cart-item-price]').textContent = moneyFormat(item.final_line_price);

      node.querySelector('[data-cherry-cart-item-decrease]').addEventListener('click', () => changeQty(item.key, item.quantity - 1));
      node.querySelector('[data-cherry-cart-item-increase]').addEventListener('click', () => changeQty(item.key, item.quantity + 1));
      node.querySelector('[data-cherry-cart-item-remove]').addEventListener('click', () => changeQty(item.key, 0));

      els.items.appendChild(node);
    });

    els.subtotal.textContent = moneyFormat(cart.items_subtotal_price ?? cart.total_price);

    renderProgress(cart);
  };

  const renderProgress = (cart) => {
    const total = cart.items_subtotal_price ?? cart.total_price;
    if (total >= FREE_SHIPPING_THRESHOLD) {
      els.progressText.innerHTML = '<strong>¡Envío gratis!</strong> Tu carrito ya lo tiene.';
      els.progressFill.style.width = '100%';
    } else {
      const remaining = FREE_SHIPPING_THRESHOLD - total;
      els.progressText.innerHTML = `Te faltan <strong>${moneyFormat(remaining)}</strong> para envío gratis`;
      els.progressFill.style.width = `${Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100)}%`;
    }
  };

  const render = (cart) => {
    state.cart = cart;
    if (!cart || cart.item_count === 0) {
      renderEmpty();
    } else {
      renderFilled(cart);
    }

    const countEl = document.querySelector('[data-cherry-cart-count]');
    if (countEl) {
      countEl.textContent = cart?.item_count ?? 0;
      countEl.style.display = (cart?.item_count ?? 0) > 0 ? '' : 'none';
    }
    const titleCount = document.querySelector('[data-cherry-cart-title-count]');
    if (titleCount) titleCount.textContent = cart?.item_count ? `· ${cart.item_count} ítem${cart.item_count === 1 ? '' : 's'}` : '';

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  };

  const changeQty = async (key, quantity) => {
    const itemEl = els.items.querySelector(`[data-key="${key}"]`);
    if (itemEl) itemEl.classList.add('is-loading');
    try {
      const cart = await fetchJSON('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ id: key, quantity }),
      });
      render(cart);
    } catch (err) {
      console.error(err);
      if (itemEl) itemEl.classList.remove('is-loading');
    }
  };

  const open = async () => {
    state.open = true;
    els.drawer.classList.add('is-open');
    els.drawer.setAttribute('aria-hidden', 'false');
    els.overlay.classList.add('is-open');
    els.overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    try {
      const cart = await getCart();
      render(cart);
    } catch (err) {
      console.error(err);
    }
  };

  const close = () => {
    state.open = false;
    els.drawer.classList.remove('is-open');
    els.drawer.setAttribute('aria-hidden', 'true');
    els.overlay.classList.remove('is-open');
    els.overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  const interceptAddToCart = () => {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const fd = new FormData(form);
      try {
        await fetch('/cart/add.js', { method: 'POST', body: fd });
        const cart = await getCart();
        render(cart);
        open();
      } catch (err) {
        console.error('Add to cart failed', err);
      }
    });
  };

  const interceptCartLink = () => {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href="/cart"], #cherry-cart-link');
      if (!link) return;
      e.preventDefault();
      open();
    });
  };

  const initTermsGate = () => {
    const box = document.querySelector('[data-cherry-cart-terms-checkbox]');
    const wrap = document.querySelector('[data-cherry-cart-terms-wrap]');
    const err = document.querySelector('[data-cherry-cart-terms-error]');
    const link = document.querySelector('[data-cherry-cart-checkout]');
    if (!box || !link) return;
    box.addEventListener('change', () => {
      if (box.checked) {
        if (err) err.hidden = true;
        if (wrap) wrap.classList.remove('cherry-cart__terms--error');
      }
    });
    link.addEventListener('click', (e) => {
      if (!box.checked) {
        e.preventDefault();
        if (err) err.hidden = false;
        if (wrap) wrap.classList.add('cherry-cart__terms--error');
      }
    });
  };

  const init = async () => {
    els.drawer = document.querySelector('[data-cherry-cart]');
    els.overlay = document.querySelector('[data-cherry-cart-overlay]');
    els.items = document.querySelector('[data-cherry-cart-items]');
    els.empty = document.querySelector('[data-cherry-cart-empty]');
    els.foot = document.querySelector('[data-cherry-cart-foot]');
    els.subtotal = document.querySelector('[data-cherry-cart-subtotal]');
    els.progress = document.querySelector('[data-cherry-cart-progress]');
    els.progressText = document.querySelector('[data-cherry-cart-progress-text]');
    els.progressFill = document.querySelector('[data-cherry-cart-progress-fill]');

    if (!els.drawer) return;

    document.querySelectorAll('[data-cherry-cart-close]').forEach((b) => b.addEventListener('click', close));
    els.overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && state.open) close();
    });

    interceptCartLink();
    interceptAddToCart();
    initTermsGate();

    try {
      const cart = await getCart();
      render(cart);
    } catch (err) {
      console.error(err);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
